/**
 * @generated SignedSource<<ca8db4aa0febf423a87f9fb4f4ead341>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type discoveryCollagePrefetchQuery$variables = Record<PropertyKey, never>;
export type discoveryCollagePrefetchQuery$data = {
  readonly gridList: ReadonlyArray<{
    readonly gridID: number;
    readonly isDeleted: boolean;
    readonly json: string | null;
    readonly name: string | null;
    readonly sellerID: number | null;
    readonly svg: string | null;
  }>;
};
export type discoveryCollagePrefetchQuery = {
  response: discoveryCollagePrefetchQuery$data;
  variables: discoveryCollagePrefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gridID",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "svg",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellerID",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeleted",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "discoveryCollagePrefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Grid",
        "kind": "LinkedField",
        "name": "gridList",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "discoveryCollagePrefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Grid",
        "kind": "LinkedField",
        "name": "gridList",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f273255061cf5e9a2b3cbd4594f22d6e",
    "id": null,
    "metadata": {},
    "name": "discoveryCollagePrefetchQuery",
    "operationKind": "query",
    "text": "query discoveryCollagePrefetchQuery {\n  gridList {\n    gridID\n    name\n    svg\n    json\n    sellerID\n    isDeleted\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c627e9591493909be7b02b13dc0506cd";

export default node;
